import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { InstallationDetailsStore, InstallationFeaturesStore } from '@store';
import {
  ActivateDeactivateCommands,
  DeviceIds,
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeaturePropertyKey,
  IsActiveProperty,
  TariffBasedFinancialOptimizationStateCommands,
  TariffBasedFinancialOptimizationStateProperty,
} from '@vi-iot/client/index';
import { GTMService } from '@services';
import { AssistantSupportedLanguages } from 'src/app/@store/assistant';
@Component({
  selector: 'app-hems-financial-optimization',
  templateUrl: './hems-financial-optimization.component.html',
  styleUrls: ['./hems-financial-optimization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsFinancialOptimizationComponent {
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly featureCommands = FeatureCommands;
  readonly assistantSupportedLanguages = AssistantSupportedLanguages;

  @Input() isForecastBasedActive: boolean;
  @Input() hemsGateway: string;
  @Input() featureTariffBasedFinancialOptimizationState: Feature<
    TariffBasedFinancialOptimizationStateProperty,
    TariffBasedFinancialOptimizationStateCommands
  >;
  @Input() featureAllowBatteryChargingFromTheGrid: Feature<
    IsActiveProperty,
    ActivateDeactivateCommands
  >;
  @Input({ required: true }) featureForecastBased: Feature<
    IsActiveProperty,
    ActivateDeactivateCommands
  >;

  constructor(
    public installationFeaturesStore: InstallationFeaturesStore,
    public installationDetailsStore: InstallationDetailsStore,
    private gtmService: GTMService
  ) {}

  onTariffBasedFinancialOptimizationChange(
    change: MatSlideToggleChange,
    feature: Feature<
      TariffBasedFinancialOptimizationStateProperty,
      TariffBasedFinancialOptimizationStateCommands
    >
  ): void {
    this.installationFeaturesStore.updateFeature(
      feature.feature,
      change.checked,
      FeaturePropertyKey.active,
      FeatureActionFields.active,
      FeatureCommands.setActive,
      this.hemsGateway,
      DeviceIds.Hems
    );
    this.gtmService.track(
      change.checked ? 'onActivate' : 'onDeactivate',
      'Tariff based financial optimization state change',
      'hems'
    );
  }

  onActivateDeactivateFeature(
    change: MatSlideToggleChange,
    feature: Feature<IsActiveProperty, ActivateDeactivateCommands>,
    gtmMessage: string
  ): void {
    this.installationFeaturesStore.updateFeature(
      feature.feature,
      {},
      FeaturePropertyKey.active,
      null,
      change.checked ? FeatureCommands.activate : FeatureCommands.deactivate,
      this.hemsGateway,
      DeviceIds.Hems
    );
    this.gtmService.track(change.checked ? 'onActivate' : 'onDeactivate', gtmMessage, 'hems');
  }
}
